import { schema } from 'normalizr';

export const authIntegrationSchema = new schema.Entity('authIntegration');
